export default "__VITE_ASSET__CAta4Z2n__"